import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classes from './tabs.module.scss';

const transitionStyle = 'left 200ms, right 200ms';

const Tabs = ({
  tabs, currentTab, setCurrentTab, defaultLinePosition, tabCounts, isIcon,
}) => {
  const tabRef = useRef(null);
  const [sizes, changeSizes] = useState(null);

  const changeTabs = ({ target }, name) => {
    setCurrentTab(name);

    const rootBounds = tabRef.current.getBoundingClientRect();
    const bounds = target.getBoundingClientRect();
    const left = bounds.left - rootBounds.left;
    const right = rootBounds.right - bounds.right;

    changeSizes({ left, right });
  };

  const getUnderlineStyle = () => {
    if (!sizes) {
      return defaultLinePosition;
    }

    return {
      left: `${sizes.left}px`,
      right: `${sizes.right}px`,
      transition: transitionStyle,
    };
  };

  return (
    <div>
      <div ref={tabRef} className={classes.tab_wrapper}>
        {tabs.map((t) => (
          <div key={t.name} className={classes.tab}>
            {isIcon && (
              <div className={`${classes.tab_title_icon} ${currentTab === t.name ? classes.active : ''}`}>
                {t.icon}
              </div>
            )}

            <div
              role="button"
              tabIndex="0"
              id={t.id || ''}
              className={`${classes.tab_title} ${currentTab === t.name ? classes.active : ''}`}
              onClick={(e) => changeTabs(e, t.name)}
              style={{ paddingLeft: isIcon ? 30 : 0 }}
            >
              {t.name}

              {!!tabCounts[t.name]
              && <div className={`${classes.count} ${classes.tab_count}`}>{tabCounts[t.name]}</div>}
            </div>
          </div>
        ))}

        <div className={classes.tabs_underline} style={getUnderlineStyle()} />
      </div>

      <div className={classes.tab_content}>
        {tabs.find(({ name }) => name === currentTab).content}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  setCurrentTab: PropTypes.func.isRequired,
  currentTab: PropTypes.string.isRequired,
  tabCounts: PropTypes.object,
  defaultLinePosition: PropTypes.object,
  isIcon: PropTypes.bool,
};

Tabs.defaultProps = {
  defaultLinePosition: {
    left: 'unset',
    right: 'unset',
  },
  tabCounts: {},
  isIcon: false,
};
export default Tabs;
